const S = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinejoin: "round", strokeLinecap: "round" };

const Cross = () => <path d="M5 5 L27 27 M27 5 L5 27" {...S} />;
const Dots = ({ n, y = 18, cx = 16 }) =>
  Array.from({ length: n }).map((_, i) => <circle key={i} cx={cx + (i - (n - 1) / 2) * 5} cy={y} r="1.6" fill="currentColor" />);

const Tub = ({ children }) => (
  <>
    <path d="M3 11 L6.5 26 H25.5 L29 11" {...S} />
    <path d="M3 11 q3.25 -3 6.5 0 t6.5 0 t6.5 0 t6.5 0" {...S} />
    {children}
  </>
);
const Num = ({ t, y = 22 }) => <text x="16" y={y} textAnchor="middle" fontSize="9" fontWeight="700" fill="currentColor">{t}</text>;
const Triangle = () => <path d="M16 4 L29 27 H3 Z" {...S} />;
const Dryer = ({ children }) => (<><rect x="4" y="4" width="24" height="24" rx="2" {...S} /><circle cx="16" cy="16" r="8.5" {...S} />{children}</>);
const Iron = ({ children }) => (<><path d="M3 24 H29 L27 15 Q25.5 9.5 18 9.5 H10 Q8 9.5 7.5 12" {...S} />{children}</>);
const Ring = ({ children }) => (<><circle cx="16" cy="16" r="11" {...S} />{children}</>);

export const CARE_GROUPS = [
  { id: "lavaggio", label: "Lavaggio", options: [
    { id: "30", label: "30°", svg: <Tub><Num t="30" /></Tub> },
    { id: "40", label: "40°", svg: <Tub><Num t="40" /></Tub> },
    { id: "60", label: "60°", svg: <Tub><Num t="60" /></Tub> },
    { id: "mano", label: "A mano", svg: <Tub><path d="M11 22 v-5 m2.5 5 v-6.5 m2.5 6.5 v-7 m2.5 7 v-6 m0 1 l3 -2" {...S} strokeWidth={1.4} /></Tub> },
    { id: "no", label: "Non lavare", svg: <Tub><Cross /></Tub> },
  ] },
  { id: "candeggio", label: "Candeggio", options: [
    { id: "si", label: "Consentito", svg: <Triangle /> },
    { id: "no", label: "Non candeggiare", svg: <><Triangle /><Cross /></> },
  ] },
  { id: "asciugatura", label: "Asciugatura", options: [
    { id: "bassa", label: "Bassa temp.", svg: <Dryer><Dots n={1} y={16} /></Dryer> },
    { id: "normale", label: "Normale", svg: <Dryer><Dots n={2} y={16} /></Dryer> },
    { id: "no", label: "No asciugatrice", svg: <Dryer><Cross /></Dryer> },
  ] },
  { id: "stiratura", label: "Stiratura", options: [
    { id: "1", label: "Bassa", svg: <Iron><Dots n={1} y={18} cx={17} /></Iron> },
    { id: "2", label: "Media", svg: <Iron><Dots n={2} y={18} cx={17} /></Iron> },
    { id: "3", label: "Alta", svg: <Iron><Dots n={3} y={18} cx={17} /></Iron> },
    { id: "no", label: "Non stirare", svg: <Iron><Cross /></Iron> },
  ] },
  { id: "professionale", label: "Lavaggio professionale", options: [
    { id: "secco", label: "A secco", svg: <Ring><Num t="P" y={20} /></Ring> },
    { id: "no", label: "Non a secco", svg: <Ring><Cross /></Ring> },
  ] },
];

const Icon = ({ svg, className = "h-8 w-8" }) => <svg viewBox="0 0 32 32" className={className}>{svg}</svg>;

export const CareSymbolPicker = ({ value = {}, onChange }) => (
  <div className="space-y-3" data-testid="care-picker">
    {CARE_GROUPS.map((g) => (
      <div key={g.id}>
        <p className="mb-1.5 text-xs text-muted-foreground">{g.label}</p>
        <div className="flex flex-wrap gap-1.5">
          {g.options.map((o) => {
            const on = value[g.id] === o.id;
            return (
              <button key={o.id} type="button" title={o.label} data-testid={`care-${g.id}-${o.id}`}
                onClick={() => onChange({ ...value, [g.id]: on ? undefined : o.id })}
                className={`flex w-16 flex-col items-center gap-0.5 rounded-md border px-1 py-1.5 transition-colors ${on ? "border-primary bg-primary/10 text-primary" : "border-border text-muted-foreground hover:border-primary/40 hover:text-foreground"}`}>
                <Icon svg={o.svg} className="h-7 w-7" />
                <span className="text-[10px] leading-tight">{o.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export const CareSymbolsView = ({ value, className = "h-6 w-6", testid }) => {
  const items = CARE_GROUPS.map((g) => g.options.find((o) => o.id === value?.[g.id])).filter(Boolean);
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 text-foreground/80" data-testid={testid}>
      {items.map((o) => <span key={o.id} title={o.label}><Icon svg={o.svg} className={className} /></span>)}
    </div>
  );
};
